import { MB_CONFIG } from '../config'

export default {

    EXAMINATION: (id) => axios.get(MB_CONFIG.API_URL + '/examination/' + id),

    DELETE: (id) => axios.delete(MB_CONFIG.API_URL + '/examination/' + id),

    SAVE: (examination) => examination.id ? axios.put(MB_CONFIG.API_URL + '/examination/' + examination.id, examination) : axios.post(MB_CONFIG.API_URL + '/examination', examination),

    DOWNLOAD: id => axios.get(MB_CONFIG.API_URL + '/examination/' + id + '/pdf', { responseType: 'blob' }),

}
